import { listHealthcareSites } from './index';

import { healthcareSitesRouteStore } from '../domain/store';

export default () => {
  if (!healthcareSitesRouteStore.http.listingHealthcareSites) return listHealthcareSites();
};
